import { http, httpV2 } from '@martech-solution/utils/utils';
import { RangeDateTypeHr } from 'src/types/date.type';
import { FlatItem, TicketResponses } from 'src/types/elements.type';
import { ApprovalStatus } from 'src/types/helpdesk/ticket.type';
import {
  AdditionalWorkingTimeTicketAdd,
  IAdditionalWorkingTimeTicket,
  IAdditionalWorkingTimeTicketDetail
} from 'src/types/hr_ticket/additionalWorkingTimeTicket.type';
import { PagedList } from 'src/types/pagedList.type';
import { IHrTicketParams } from 'src/types/params.type';

const controller = 'hr/additional-working-time-tickets';

export const getAdditionalWorkingTimeTickets = async (params: IHrTicketParams) => {
  return await http.get<PagedList<IAdditionalWorkingTimeTicket>>(controller, {
    params: params
  });
};

export const getAdditionalWorkingTimeTicketsApproval = async (params: IHrTicketParams) => {
  return await http.get<PagedList<IAdditionalWorkingTimeTicket>>(`${controller}/waiting-approval`, {
    params: params
  });
};

export const getAdditionalWorkingTimeTicket = async (id: number) => {
  return await http.get<IAdditionalWorkingTimeTicket>(`${controller}/${id}`);
};

// export const getAdditionalWorkingTimeTicketsByPackage = async (packageId: number, params: IHrTicketParams) => {
//   return await http.get<PagedList<IAdditionalWorkingTimeTicket>>(`${controller}/details/package/${packageId}`, {
//     params: params
//   });
// };

// export const getApprovalsAdditionalWorkingTimeTicketByPackage = async (
//   packageId: number,
//   params: AdditionalWorkingTimeTicketDetailFilterParams
// ) => {
//   return await http.get<PagedList<IAdditionalWorkingTimeTicketDetail>>(
//     `${controller}/details/approval-tickets/package/${packageId}`,
//     {
//       params: params
//     }
//   );
// };

// export const getRefAdditionalWorkingTimeTicketsForTicket = async (refTicketId: string) =>
//   await http.get<IAdditionalWorkingTimeTicket[]>(`${controller}/get-ref-tickets/${refTicketId}`);

export const getAdditiontalWorkingTimeTicketDropdown = async () => {
  return http.get<FlatItem[]>(`${controller}/dropdown`);
};

export const getAdditionalWorkingTimeTicketWaitingProcessingCount = async (params: RangeDateTypeHr) => {
  return await http.get(`${controller}/count-ticket-waiting-processing`, {
    params: params
  });
};

export const addAdditionalWorkingTimeTicket = async (additionalWorkingTimeTicket: AdditionalWorkingTimeTicketAdd) => {
  return await http.post(controller, additionalWorkingTimeTicket);
};

export const getAdditionalWorkingTimeTicketApprovalCount = async (params: RangeDateTypeHr) => {
  return await http.get(`${controller}/count-handle-tickets`, {
    params: params
  });
};

export const getMyAdditionalWorkingTimeTicketCount = async (params: RangeDateTypeHr) => {
  return await http.get(`${controller}/count-my-tickets`, {
    params: params
  });
};

export const updateAdditionalWorkingTimeTicket = async (
  id: number,
  additionalWorkingTimeTicket: AdditionalWorkingTimeTicketAdd
) => {
  return await http.put(`${controller}/${id}`, additionalWorkingTimeTicket);
};

export const deleteAdditionalWorkingTimeTicket = async (id: number) => {
  return await http.delete(`${controller}/${id}`);
};

export const cancelAdditionalWorkingTimeTicket = async (id: number) => {
  return await http.put(`${controller}/${id}/cancel`);
};

export const approvalAdditionalWorkingTimeTickets = async (
  ticketResponses: TicketResponses[],
  approvalStatus: ApprovalStatus,
  note?: string
) =>
  await http.put(`${controller}/approvals`, {
    ticketResponses: ticketResponses,
    approvalStatus,
    note: note ? note : ''
  });

export const approvalQuickAdditionalWorkingTimeTickets = async (
  ticketIds: number[],
  approvalStatus: ApprovalStatus,
  note?: string
) => {
  return await httpV2.put(`${controller}/approvals`, ticketIds, {
    params: { approvalStatus, note }
  });
};

export const cancelApprovalAdditionalWorkingTimeTicket = async (id: string, step: number) =>
  await http.put(`${controller}/${id}/cancel-approval`, { step });

export const updateStatusDetail = async (id: number, isRejected: boolean) => {
  return await http.put(`${controller}/details/update-status/${id}`, { isRejected });
};

export const printAdditionalWorkingTimeTicket = async (id: number) =>
  await http.get(`${controller}/print`, {
    params: {
      id: id
    },
    responseType: 'blob'
  });

export const getAdditionalWorkingTimeDetailsUsed = async (fromDate: string, toDate: string, employeeCode?: string) => {
  return await http.get<IAdditionalWorkingTimeTicketDetail[]>(
    `${controller}/used-ticket-detail/${fromDate}/${toDate}`,
    {
      params: {
        employeeCode
      }
    }
  );
};

export const getAdditionalWorkingTimeTicketsHrConfirm = async (params: IHrTicketParams) => {
  return await http.get<PagedList<IAdditionalWorkingTimeTicket>>(controller, {
    params: params
  });
};

export const getAdditionalWorkingTimeTicketHrConfirmCount = getMyAdditionalWorkingTimeTicketCount;

export const uploadAdditionalWorkingTimeTicketFile = async (files: File[]) => {
  const formData = new FormData();
  files.forEach((file) => {
    formData.append('files', file as File);
  });
  return await httpV2.post<string>(`${controller}/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const getAdditionalWorkingTimeTicketFile = async (fileUrl: string, fileName?: string) => {
  return await httpV2.get<Blob>(`${controller}/get-file`, {
    params: {
      fileUrl,
      fileName
    },
    responseType: 'blob'
  });
};
